<script setup>
import { ref, defineProps } from "vue";
import ReactPrice from "@/components/basic/react-components/price/Index.vue";

defineProps({
  variant: {
    type: Object,
    default: () => {},
  },
});

const productPrice = ref(null);

// 处理价格事件
const handlePriceChange = ({ price }) => {
  productPrice.value = price.formattedPrice;
};

</script>

<template>
  <div>
    <ReactPrice :variant="variant"  @price-change="handlePriceChange" />
    <span class="csr-commerce-price">{{ productPrice }}</span>
  </div>
</template>